import { times } from 'lodash';

import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function BottomMark() {
    const { t } = useLang('powerstream.detail.bottomMark');
    const marksArr = times(2, (i) => ({ key: i, text: `mark_${i + 1}` }));

    return (
        <div className={styles.bottomMark}>
            <div className="bottom-mark">
                <div className="bottom-mark__text">
                    {marksArr?.map((markItem: any, index: number) => (
                        <div key={markItem.key} className="mark-item">
                            <div className="mark-item-index">{`${index + 1}.`} </div>
                            <p className="mark-item-text">
                                {t.rich(markItem.text, {
                                    LinkText1: (text: any) => <span className="source-text">{text}</span>,
                                    LinkText2: (text: any) => (
                                        <span
                                            className="link-text"
                                            onClick={() => {
                                                window.open(text);
                                            }}
                                        >
                                            {text}
                                        </span>
                                    ),
                                })}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
